import Icon from 'oxyrion-ui/lib/Icon';
import React, { Component } from 'react';
import styled from 'styled-components';

import { __ } from '../../Utils';

const Wrapper = styled.div`
  width: 100%;
  height: ${props => `${props.height - props.height / 3}px`};
  display: flex;
  padding-top: ${props => `${props.height / 3}px`};
  /* justify-content: center; */
  align-items: center;
  flex-direction: column;
  background: #ff6b6b;
`;

const ErrorTitle = styled.div`
  font-size: 64px;
  font-weight: bold;
  margin-bottom: 32px;
  color: #f1f1f1;
`;

const ErrorSubTitle = styled.div`
  font-size: 24px;
  margin-bottom: 64px;
  color: #f1f1f1;
`;

const ErrorButton = styled.a`
  padding: 12px 24px 12px 24px;
  font-size: 28px;
  border: 3px solid #f1f1f1;
  color: #f1f1f1;
  border-radius: 12px;
  text-decoration: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  :hover {
    /* text-decoration: underline; */
  }
`;

const IconWrapper = styled.div`
  border: 7px solid #f1f1f1;
  border-radius: 64px;
  margin-bottom: 24px;
`;

const ErrorButtonIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 16px;
`;

class ErrorFalbackComponent extends Component {
  render() {
    return (
      <Wrapper height={window.innerHeight}>
        {/* <img src={errorImage} /> */}
        <IconWrapper>
          <Icon name="close" size="xxl" color="#f1f1f1" />
        </IconWrapper>
        <ErrorTitle>{__('Nastala neočakávana chyba')}</ErrorTitle>
        <ErrorSubTitle>
          {__(
            'Ospravedlňujeme sa za spôsobené komplikácie. O chybe sme boli automaticky oboznámení a pracujeme na jej odstranení',
          )}
          .
        </ErrorSubTitle>

        <ErrorButton href="/">
          <ErrorButtonIconWrapper>
            <Icon name="home" color="#f1f1f1" size="xl" />
          </ErrorButtonIconWrapper>
          {__('Prejsť na domovskú stránku')}
        </ErrorButton>
      </Wrapper>
    );
  }
}

ErrorFalbackComponent.propTypes = {};

ErrorFalbackComponent.defaultProps = {};

export default ErrorFalbackComponent;



// WEBPACK FOOTER //
// ./src/Components/ErrorFalbackComponent/index.jsx